export const SET_USER = 'SET_USER'
export const SET_ROOMNAME = 'SET_ROOMNAME'
export const SET_SELECTED_MENU_ITEM = 'SET_SELECTED_MENU_ITEM'
export const SET_DEBUG = 'SET_DEBUG'
export const SET_LOCAL_BRIDGE = 'SET_LOCAL_BRIDGE'
export const SET_MESSAGE_CODE = 'SET_MESSAGE_CODE'
export const SET_HOST = 'SET_HOST'

/** Token Actions */
export const TOKEN_FETCH = 'TOKEN_FETCH'
export const TOKEN_SUCCESS = 'TOKEN_SUCCESS'
export const TOKEN_ERROR = 'TOKEN_ERROR'

/** Room Actions */
export const SET_WEBCAM_ERROR = 'SET_WEBCAM_ERROR'
export const SET_CHANNEL_AND_WEBCAST = 'SET_CHANNEL_AND_WEBCAST'
export const SET_ROOM_AND_USER = 'SET_ROOM_AND_USER'
export const SET_LOCAL_ROOM_LISTENERS = 'SET_LOCAL_ROOM_LISTENERS'
export const SET_ROOM_LISTENERS = 'SET_ROOM_LISTENERS'
export const JOIN_ROOM = 'JOIN_ROOM'
export const NEW_DATA = 'NEW_DATA'
export const TOGGLE_PRESENTER_MUTE = 'TOGGLE_PRESENTER_MUTE'
export const FORCE_LOCAL_MUTE = 'FORCE_LOCAL_MUTE'
export const FORCE_LOCAL_MUTE_DISABLE = 'FORCE_LOCAL_MUTE_DISABLE'
export const OPEN_SIDE_PANEL = 'OPEN_SIDE_PANEL'
export const CLOSE_SIDE_PANEL = 'CLOSE_SIDE_PANEL'
export const HIDE_PRESENTER = 'HIDE_PRESENTER'
export const DISCONNECT_USER = 'DISCONNECT_USER'
export const DISCONNECT_USER_SUCCESS = 'DISCONNECT_USER_SUCCESS'
export const RESET_SESSION = 'RESET_SESSION'
export const SEND_DEBUG_STATS = 'SEND_DEBUG_STATS'
export const HIDE_ITS_TIME = 'HIDE_ITS_TIME'
export const NETWORK_QUALITY_CHANGE = 'NETWORK_QUALITY_CHANGE'
export const LOCAL_TRACKS_ADDED = 'LOCAL_TRACKS_ADDED'
export const LOCAL_TRACKS_FAILED = 'LOCAL_TRACKS_FAILED'
export const SET_DEVICE_PERMISSIONS = 'SET_DEVICE_PERMISSIONS'

/** Booking Actions */
export const SET_BOOKING_STATUS = 'SET_BOOKING_STATUS'
export const SET_LIVE_TIME = 'SET_LIVE_TIME'
export const REMOVE_BOOKING_DOC = 'REMOVE_BOOKING_DOC'
export const REMOVE_UI_DOC = 'REMOVE_UI_DOC'
export const REMOVE_PLAY_IN_DOC = 'REMOVE_PLAY_IN_DOC'

/** Sync Actions */
export const SET_UI_DOCUMENT = 'SET_UI_DOCUMENT'
export const SET_BOOKING_DOCUMENT = 'SET_BOOKING_DOCUMENT'
export const SET_PLAY_IN_DOCUMENT = 'SET_PLAY_IN_DOCUMENT'
export const SET_SLIDES_DOCUMENT = 'SET_SLIDES_DOCUMENT'
export const DOCUMENT_BOOKING_LISTENERS_ADDED = 'DOCUMENT_BOOKING_LISTENERS_ADDED'
export const SET_UI_DOCUMENT_STATE_COMPLETE = 'SET_UI_DOCUMENT_STATE_COMPLETE'
export const SET_BOOKING_DOCUMENT_STATE_COMPLETE = 'SET_BOOKING_DOCUMENT_STATE_COMPLETE'
export const UPDATE_UI_DOC_SUCCESS = 'UPDATE_UI_DOC_SUCCESS'
export const UPDATE_UI_DOC_ERROR = 'UPDATE_UI_DOC_ERROR'
export const UI_DOC_RESET_STATUS_SUCCESS = 'UI_DOC_RESET_STATUS_SUCCESS'
export const UI_DOC_RESET_STATUS_ERROR = 'UI_DOC_RESET_STATUS_ERROR'
export const SET_PRESENTER_COUNT = 'SET_PRESENTER_COUNT'
export const SET_FOCUS = 'SET_FOCUS'
export const CLEAR_FOCUS = 'CLEAR_FOCUS'
export const UNSET_FOCUS = 'UNSET_FOCUS'
export const SET_BRIDGE_DATA_DOCUMENT = 'SET_BRIDGE_DATA_DOCUMENT'
export const REMOVE_BRIDGE_DATA_DOCUMENT = 'REMOVE_BRIDGE_DATA_DOCUMENT'

export const EXTEND_GIG_TERMINATION = 'EXTEND_GIG_TERMINATION'
export const EXTEND_GIG_TERMINATION_SUCCESS = 'EXTEND_GIG_TERMINATION_SUCCESS'

/** Track Actions */
export const SET_AVAILABLE_DEVICES = 'SET_AVAILABLE_DEVICES'

export const SET_ROLE = 'SET_ROLE'

/** Twilio Actions */
export const SET_FEATURE_FLAG = 'SET_FEATURE_FLAG'

export const SET_MEDIA_TYPE_STATE = 'SET_MEDIA_TYPE_STATE'
